
import { Info } from "lucide-react";
import { useState } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface RedactedCompanyNameProps {
  companyName: string;
}

export const RedactedCompanyName = ({ companyName }: RedactedCompanyNameProps) => {
  const [isHovered, setIsHovered] = useState(false);
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span 
            className={`relative inline-flex items-center bg-black text-transparent px-2 py-0.5 rounded cursor-help transition-all duration-300 ${isHovered ? 'bg-opacity-80' : 'bg-opacity-100'}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            aria-label="Redacted company name"
          >
            <span className="select-none">{companyName}</span>
            <Info className={`h-3 w-3 text-white absolute right-1 opacity-0 transition-opacity duration-300 ${isHovered ? 'opacity-100' : ''}`} />
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs bg-gray-900 text-white border-gray-800">
          <p className="text-sm">We protect our clients' identities when discussing their security programs to maintain confidentiality and prevent them from becoming targeted.</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
